import {EditUser} from './EditUser';
import {AddUser} from "./AddUser";


export const ButtonFunctions = [AddUser, EditUser];

